import { useTranslation } from 'react-i18next';
import { ArticleJobAction } from '../ArticleJobAction';
import { useCreateArticle } from './useCreateArticle';

export function CreateArticleAction() {
  const { t } = useTranslation();
  const createArticle = useCreateArticle();
  return (
    <ArticleJobAction
      variant="sidebar"
      title={t(
        createArticle.canSubmit
          ? 'article.copy.readyToCreate'
          : 'article.copy.reviewRequired',
      )}
      description={t(
        createArticle.creationTargets.length === 1
          ? 'article.create.singleHint'
          : 'article.create.jobHint',
      )}
      buttonLabel={t('article.create.actionTitle', {
        count: createArticle.creationTargets.length,
      })}
      showIgnoreClashes={!createArticle.firstArticleClashes}
      ignoreClashes={createArticle.skipUnavailable}
      ignoredCount={createArticle.ignoredCount}
      onIgnoreChange={(value) =>
        createArticle.setValue('skipUnavailable', value)
      }
      canSubmit={createArticle.canSubmit}
      loading={createArticle.creationRequest.loading}
      onSubmit={createArticle.submit}
    />
  );
}
